var exports = {
  "kL": "xa15a2ab7--087f31--container",
  "jW": "xa15a2ab7--087f31--photo",
  "Hn": "xa15a2ab7--087f31--cell",
};

module.exports = exports;
